import { Module } from "vuex";

export const Receipt: Module<any, any> = {
  state: {
    querySearch: {},
    currentPageReceipt: {},
  },
  getters: {
    querySearch: (state) => state.query,
    currentPageReceipt: (state) => state.query,
  },
  mutations: {
    setquerySearch(state, data) {
      state.querySearch = data;
    },
    setcurrentPageReceipt(state, data) {
      state.currentPageReceipt = data;
    },
  },
  actions: {
    setcurrentPageReceipt(data) {
      console.log(data);
      data.commit("setcurrentPageReceipt");
    },
    setquerySearch(query) {
      query.commit("setquerySearch");
    },
  },
};
